import React from 'react';
import {NativeStackScreenProps} from '@react-navigation/native-stack';
import {StackParamList} from '../../../../../navigators';
import {SuccessTemplate} from '../../../../../components/templates/success';
import {
  PrimaryButton,
  SecondaryButton,
} from '../../../../../components/buttons';
import {message} from '../../../../../utils/messages';

type ScreenProps = NativeStackScreenProps<
  StackParamList,
  'PaymentCreditCardSuccessScreen'
>;

export const PaymentCreditCardSuccessScreen = ({navigation}: ScreenProps) => {
  const handlePrimaryPress = async () => {
    navigation.reset({
      index: 0,
      routes: [{name: 'Dashboard'}],
    });
  };

  const handleSecondaryPress = () => {
    navigation.reset({
      index: 0,
      routes: [{name: 'UnpaidedBillListScreen'}],
    });
  };

  return (
    <SuccessTemplate
      title={message('credit-card-payment-success-title')}
      summary={message('credit-card-payment-success-success-summary')}>
      <PrimaryButton
        label={message('fee-payment-success-primary-button')}
        onPress={() => handlePrimaryPress()}
      />
      <SecondaryButton
        label={message('fee-payment-success-seccndary-button')}
        mt="5"
        onPress={() => handleSecondaryPress()}
      />
    </SuccessTemplate>
  );
};
